import { isPositiveNumber } from "et3-type-guards";
import { useNavigate } from "react-router-dom";

import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import { getPermissionIDRequired } from "../../../../../helpers/et3-has-permission";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import SummaryNavButton from "./SummaryNavButton";
import {
  SUMMARY_HEADER_IDENTITY_HEIGHT,
  SUMMARY_HEADER_ITEM_GAP,
  SUMMARY_HEADER_ROW_GAP
} from "./summary-header-constants";

const SummaryNavButtons = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const navigate = useNavigate();
  const userID = getUserAdvancedStore().currentUserId.get();
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const hasUserMessagesPermission = isPositiveNumber(
    userPermissions.indexOf(getPermissionIDRequired("User-Messages")),
    true
  );
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const userStatusDeleted = getUserAdvancedStore().userStatusDeleted.get();

  const goTo = async (
    pathname: string,
    eventName:
      | "GO_TO_MESSAGES"
      | "GO_TO_PAYMENTS"
      | "GO_TO_EVENTS"
      | "GO_TO_EDIT_PROFILE"
      | "GO_TO_USER_CONSUMABLES"
  ) => {
    navigate({ pathname, search: `id=${userID}` });
    if (eventName === "GO_TO_EVENTS") {
      getUserAdvancedStore().goToUserEvents(userID);
    }
    await getCorePersonalStore().insertAdminEvent({
      eventName,
      fromPage: "USER_ADVANCED",
      userID: userID,
      extraData: {}
    });
  };

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={SUMMARY_HEADER_IDENTITY_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{
        width: "auto",
        height: "auto",
        minHeight: 0,
        minWidth: 0,
        flexWrap: "wrap",
        gap: `${SUMMARY_HEADER_ROW_GAP * unitY}px ${
          SUMMARY_HEADER_ITEM_GAP * unitX
        }px`
      }}
      onClick={() => {}}
    >
      {hasUserMessagesPermission ? (
        <SummaryNavButton
          labelKey={"USER_MESSAGES"}
          isEnabled={true}
          onPress={async () => await goTo("/users/messages", "GO_TO_MESSAGES")}
        />
      ) : null}
      <SummaryNavButton
        labelKey={"USER_PAYMENTS"}
        isEnabled={true}
        onPress={async () => await goTo("/users/payments", "GO_TO_PAYMENTS")}
      />
      <SummaryNavButton
        labelKey={"USER_EVENTS"}
        isEnabled={true}
        onPress={async () => await goTo("/users/events", "GO_TO_EVENTS")}
      />
      {isAnyKhattabaAdmin ? null : (
        <SummaryNavButton
          labelKey={"EDIT_USER_DATA"}
          isEnabled={!userStatusDeleted}
          onPress={async () =>
            await goTo("/users/editProfile", "GO_TO_EDIT_PROFILE")
          }
        />
      )}
      {isAnyKhattabaAdmin ? null : (
        <SummaryNavButton
          labelKey={"CONSUMABLES"}
          isEnabled={!userStatusDeleted}
          onPress={async () =>
            await goTo("/users/consumables", "GO_TO_USER_CONSUMABLES")
          }
        />
      )}
    </ET3Div>
  );
});
export default SummaryNavButtons;
